<template>
    <div class="d-flex f-row">
		<div class="f-column" style="width:50%; min-width: 400px;">
				<v-row><v-col>
				<v-autocomplete outlined dense
					hide-details="auto"
					:disabled="loading"
					v-model="relayCompetitor.selected"
					:items="competitors"
					return-object
					hide-no-data
					:label="$t('text.competitor')"
					:loading="competitorLoading"
					@keyup="filterCompetitors"
					@input="$v.relayCompetitor.selected.$touch()"
					@blur="$v.relayCompetitor.selected.$touch()"
				></v-autocomplete>
				</v-col></v-row>
				<v-row v-show="isMultiTeamEvent && isrelayCompetitorSelected"><v-col>
				<v-text-field outlined dense
					hide-details="auto"
					:label="$t('text.bestResult')"
					v-model="value"
					:error-messages="valueErrors"
					required
					@keyup="formatValue"
					@input="$v.value.$touch()"
					@blur="$v.value.$touch()"
				></v-text-field>
				</v-col></v-row>
		</div>
		<div style="padding:12px;">
			<v-btn
				class="mr-4"
				:disabled="maxRelayCompetitors || loading || (!isrelayCompetitorSelected && value != '')"
				@click="addRelayCompetitor"
			>{{ $t(`text.addButton`) }}</v-btn>
		</div>
		<div class="relayList f-grow">
			<div class="relay-row"><b>{{ $t(`text.relayMembers`) }} ({{relayCompetitor.list.length}}/{{relayMembers}})<span v-if="isMultiTeamEvent">&nbsp;- {{multiTeamEventSum}}</span></b></div>
			<div v-for="(rComp, i) in relayCompetitor.list" :key="rComp.guid" class="relay-row">
				<div class="f-grow competitor-label"><b v-if="isMultiTeamEvent">({{ rComp.value }})</b> {{ rComp.name }}</div>
				<div class="button-row">
					<span v-if="i !== 0" :class="{'last-button': i === (relayCompetitor.list.length - 1)}">
						<v-btn
							class="mr-4"
							:disabled="loading"
							@click="moveRelayCompUp(i)">
							<v-img
								max-width="25"
								min-width="25"
								:src="require('../assets/up.png')">
							</v-img>
						</v-btn>
					</span>
					<span v-if="i !== (relayCompetitor.list.length - 1)">
						<v-btn
							class="mr-4"
							:disabled="loading"
							@click="moveRelayCompDown(i)">
							<v-img
								max-width="25"
								min-width="25"
								:src="require('../assets/down.png')">
							</v-img>
						</v-btn>
					</span>
					<span>
						<v-btn
							class="mr-4"
							:disabled="loading"
							@click="removeRelayCompetitor(i)">
							<v-img
								max-width="25"
								min-width="25"
								:src="require('../assets/bin.png')">
							</v-img>
						</v-btn>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { requiredIf } from 'vuelidate/lib/validators';
import modelState from '../mixins/modelState';
import formater from '../mixins/formater';

export default {
	name: 'RelayEditor',
	mixins: [modelState, formater],
	validations: {
		relayCompetitor: {
			selected: {
			},
		},
		value: {
			// eslint-disable-next-line func-names
			required: requiredIf(function () {
				return this.isMultiTeamEvent;
			}),
			// required,
			String,
		},
	},
	data() {
		return {
			relayCompetitor: {
				selected: this.defaultNullCompetitor,
				list: [],
			},
			value: 0,
		};
	},
	props: {
		loading: {
			type: Boolean,
			require: true,
			default: true,
		},
		competitors: {
			default: () => [],
			require: true,
		},
		competitorLoading: {
			type: Boolean,
			require: true,
			default: true,
		},
		relayMembers: {
			require: true,
			type: Number,
		},
		relayCompList: {
			require: true,
			default: () => [],
		},
		multiTeamEvent: {
			type: Boolean,
			require: false,
			default: false,
		},
		measurement: {
			type: String,
			required: false,
			default: 's',
		},
	},
	computed: {
		isMultiTeamEvent() {
			return this.multiTeamEvent;
		},
		maxRelayCompetitors() {
			return this.relayCompetitor.list.length >= this.relayMembers;
		},
		multiTeamEventSum() {
			let sum = 0;
			if (this.measurement === 'p') return this.relayCompetitor.list.length != 0 ? this.relayCompetitor.list.reduce((a, b) => Number.parseFloat(a, 10) + (Number.parseFloat(b.value, 10) || 0), 0) : 0;
			if (this.relayCompetitor.list.length === 1) return this.relayCompetitor.list[0].value;
			sum = this.relayCompetitor.list.length != 0 ? this.relayCompetitor.list.map(x => x.value).reduce((a, b) => {
				let res = 0;
				// eslint-disable-next-line no-restricted-globals
				if (isNaN(a)) {
					res = this.calcSeconds(a);
				} else {
					res = a;
				}
				return res + this.calcSeconds(b);
			}) : 0;
			if (sum>86400) {
				let hours = new Date(sum * 1000).getUTCHours();
				let minsec = new Date(sum * 1000).toISOString().substr(14, 5);
				let day = new Date(sum * 1000).toISOString().substr(9, 1);
				hours = hours + ((day-1) * 24);
				return hours + ':' + minsec;
			}
			else {
				return new Date(sum * 1000).toISOString().substr(11, 8);
			}
		},
		isrelayCompetitorSelected() {
			return this.relayCompetitor.selected !== '' && this.relayCompetitor.selected !== undefined && this.relayCompetitor.selected !== null && this.relayCompetitor.selected !== this.nullRelayCompetitor;
		},
		nullRelayCompetitor() {
			return !this.isRelayEvent ? '00000000-0000-0000-0000-000000000000' : null;
		},
		valueErrors() {
			const errors = [];

			if (!this.$v.value.$dirty) return errors;

			const apiErrors = this.validateProperty('valueErrors');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			return errors;
		},
	},
	methods: {
		calcSeconds(t) {
			if ((typeof t !== 'string') || !t.includes(':')) return 0;
			const s = t.split(':').reverse();
			let res = Number.parseInt(s[0], 10) + Number.parseInt(s[1], 10) * 60;
			if (s[2]) res += Number.parseInt(s[2], 10) * 3600;
			return res;
		},
		async filterCompetitors(val) {
			if (val.target.value && val.target.value.trim().length >= 3) {
				this.$emit('competitor-search', val);
			}
		},
		formatValue() {
			this.value = this.gFormatbestResult(this.value, this.measurement);
		},
		addRelayCompetitor() {
			if (this.relayCompetitor.list.findIndex(x => x.guid === this.relayCompetitor.selected.value) === -1) {
				this.relayCompetitor.list.push({ guid: this.relayCompetitor.selected.value, name: this.relayCompetitor.selected.text, value: this.value });
			}
			this.relayCompetitor.selected = null;
			this.value = 0;
			this.$emit('competitor-changed', this.relayCompetitor.list);
		},
		removeRelayCompetitor(id) {
			this.relayCompetitor.list.splice(id, 1);
			this.$emit('competitor-changed', this.relayCompetitor.list);
		},
		moveRelayCompUp(id) {
			const el = this.relayCompetitor.list[id];
			this.relayCompetitor.list.splice(id, 1);
			this.relayCompetitor.list.splice(id - 1, 0, el);
			this.$emit('competitor-changed', this.relayCompetitor.list);
		},
		moveRelayCompDown(id) {
			const el = this.relayCompetitor.list[id];
			this.relayCompetitor.list.splice(id, 1);
			this.relayCompetitor.list.splice(id + 1, 0, el);
			this.$emit('competitor-changed', this.relayCompetitor.list);
		},
	},
	watch: {
		// eslint-disable-next-line object-shorthand
		relayCompList: function () {
			if (this.relayCompList.length === 0) this.relayCompetitor.list = this.relayCompList;
		},
	},
	mounted() {
		this.relayCompetitor.list = this.relayCompList;
	},
};
</script>

<style lang="scss" scoped>
.relayList {
    font-size:16px;
	color: rgba(0, 0, 0, 0.87);
	padding-bottom: 10px;
}
.relay-row {
	display:flex;
	flex-direction:row;
	line-height:45px;
	border-bottom: 1px solid silver;
	padding-left:5px;
}
.relay-column {
	display:flex;
	flex-direction:column;
	line-height:45px;
	border-bottom: 1px solid silver;
	padding-left:5px;
}
.d-flex {
	display:flex;
}
.f-row {
	flex-direction: row;
	display:flex;
}
.f-grow {
	flex-grow:1;
}
.button-row {
	min-width:240px;
	text-align: right;
}
.last-button {
	margin-right: 80px;
}
.competitor-label{
	overflow:hidden;
	height: 45px;
}
</style>
